import "layui";
import "layui/dist/css/layui.css";
import "swiper/css/swiper.min.css";
import Swiper from "swiper";
import $ from "jquery";
import "@/css/homepage.scss";
import newNav from "../util/newNav";
import footers from "../util/footer";

const newNAv = newNav();
$("body").append(newNAv);
const publicfooters = footers();
$("body").append(publicfooters);
function init() {
  //导航
  // newNav();
  //轮播图
  //banner();
  //核心技术
  core();
  //联系我们
  contact();
  // scheme();
  bannerSwiper();
}
$(document).ready(function () {
  init();
});

function contact() {
  layui.use(function () {
    let util = layui.util;
    let layer = layui.layer;
    let form = layui.form;
    // 自定义固定条
    util.fixbar({
      bars: [
        {
          type: "contact",
          icon: "layui-icon-survey",
        },
      ],
      default: true, // 是否显示默认的 bar 列表 --  v2.8.0 新增
      bgcolor: "#00AD7B", // bar 的默认背景色
      css: { bottom: 100 },
      // target: '#target-test', // 插入 fixbar 节点的目标元素选择器
      on: {
        // 任意事件 --  v2.8.0 新增
      },
      // 点击事件
      click: function (type) {
        if (type === "contact") {
          layer.open({
            type: 1,
            title: false,
            closeBtn: 0,
            content: `
                        <div class="contact-form">
                            <form class="layui-form" lay-filter="form-submit">
                                <div class="contact-title">联系我们</div>
                                <div class="layui-form-item">
                                    <div class="layui-input-wrap">
                                        <div class="layui-input-prefix">
                                          <i class="layui-icon layui-icon-templeate-1"></i>
                                        </div>
                                      <input type="text" name="companyName" lay-verify="required" lay-reqtext="请输入公司名称" placeholder="公司名称" autocomplete="off" class="layui-input">
                                    </div>
                                </div>
                                <div class="layui-form-item">
                                    <div class="layui-input-wrap">
                                        <div class="layui-input-prefix">
                                          <i class="layui-icon layui-icon-form"></i>
                                        </div>
                                      <input type="text" name="industry" lay-verify="required" lay-reqtext="请输入所属行业" placeholder="所属行业" autocomplete="off" class="layui-input">
                                    </div>
                                </div>
                                <div class="layui-form-item">
                                    <div class="layui-input-wrap">
                                        <div class="layui-input-prefix">
                                          <i class="layui-icon layui-icon-username"></i>
                                        </div>
                                        <input type="text" name="contactName" lay-verify="required" lay-reqtext="请输入联系姓名" placeholder="联系姓名" autocomplete="off" class="layui-input">
                                    </div>
                                </div>
                                <div class="layui-form-item">
                                    <div class="layui-input-wrap">
                                        <div class="layui-input-prefix">
                                          <i class="layui-icon layui-icon-cellphone"></i>
                                        </div>
                                        <input type="tel" name="phoneNumber" lay-verify="required|phone" lay-reqtext="请输入手机号" placeholder="手机号" lay-affix="clear" autocomplete="off"  class="layui-input">
                                    </div>
                                </div>
                                <div class="layui-form-item">
                                    <div class="layui-input-wrap">
                                        <div class="layui-input-prefix">
                                          <i class="layui-icon layui-icon-tabs"></i>
                                        </div>
                                      <input type="text" name="jobTitle" lay-verify="required" lay-reqtext="请输入担任职务" placeholder="担任职务" autocomplete="off" class="layui-input">
                                    </div>
                                </div>
                                <div class="layui-form-item">
                                    <div class="layui-input-wrap">
                                        <textarea name="companyDescription" lay-verify="required" lay-reqtext="请输入公司简介" placeholder="公司简介" class="layui-textarea"></textarea>
                                    </div>
                                </div>
                            </form> 
                        </div>
                        `,
            area: ["500px", "550px"],
            resize: false,
            scrollbar: false,
            btn: ["提交", "取消"],
            btn1: function (index) {
              // 验证表单信息
              form.submit("form-submit", function (data) {
                let field = data.field; // 获取表单全部字段值
                // 执行提交
                layer.confirm("确定提交吗？", function () {
                  // 发送请求
                  contactUs(index, field);
                });
              });
              return false;
            },
          });
        }
      },
    });
  });
}

// 发送请求，保存联系我们数据
function contactUs(index, data) {
  layui.use(function () {
    let layer = layui.layer;
    $.ajax({
      url: "/singleSignLogin/salary-api/api/website/contactUs/create",
      type: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      dateType: "json",
      data: JSON.stringify(data),
      success: function (res) {
        if (res.code == 200) {
          layer.msg("提交成功", { icon: 1 });
          layer.close(index); // 关闭弹层
        } else {
          layer.msg("系统错误", { icon: 2 });
        }
      },
      error: function (data) {
        layer.msg("提交失败", { icon: 2 });
      },
    });
  });
}

function banner() {
  let bannerData = [
    {
      img: "../imgs/homepage/lun1.jpg",
      title1: "供热源网荷储一体化智慧平台",
      title2:
        "构建 “需求感知 - 智能分配 - 精准供热” 的全链路闭环，实现供热资源的高效利用与低碳运营。",
      more: "了解详情",
      id: 1,
    },
    {
      img: "../imgs/homepage/lun2.jpg",
      title1: "AI大模型应用创新加速计划",
      title2:
        "为AI创新探索者提供AI应用得安全测评和实时防御,确保创新与安全并行,解锁AI未来得无限可能。",
      more: "了解详情",
      id: 2,
    },
    {
      img: "../imgs/homepage/lun3.jpg",
      title1: "创新数据链开启价值新时代",
      title2:
        "构建起一个从数据采集、传输、存储到分析、应用、交易的全生命周期生态系统",
      more: "了解详情",
      id: 3,
    },
  ];
  //用jquery循环获取bannerData所有数据
  $.each(bannerData, function (index, item) {
    //<div class="swiper-img"><img src="${item.img}" alt=""></div>
    let bannerTemplate = `
                           <div class="swiper-slide">
                                <div class="swiper-content" style="background-image: url(${item.img});">
                                    <div class="swiper-title1">${item.title1}</div>
                                    <div class="swiper-title2">${item.title2}</div>
                                    <div class="swiper-more"><a href="">${item.more}</a></div>
                                </div>
                           </div> 
                         `;
    $(".swiper-wrapper").append(bannerTemplate);
  });
  //获取所有的swiper-slide中的swiper-more下a标签中的内容,如果有内容,就显示,没有内容,就隐藏
  $(".swiper-more a").each(function () {
    if ($(this).text() == "") {
      $(this).parent().hide();
    } else {
      $(this).parent().show();
    }
  });
  //判断swiper-content有几个swiper-slide
  const slideCount = $(".bannerChild .swiper-wrapper .swiper-slide").length;
  if (slideCount <= 1) {
    console.log("小于1");
  } else {
    bannerSwiper();
  }
}
function bannerSwiper() {
  var mySwiper = new Swiper(".swiper", {
    loop: true, // 启用循环模式
    autoplay: {
      delay: 3000, // 自动播放的间隔时间（毫秒）
      disableOnInteraction: false, // 用户操作后是否继续自动播放
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    scrollbar: {
      el: ".swiper-scrollbar",
    },
  });
}

//专注核心技术突破
function core() {
  let coreData = [
    {
      img: "../imgs/homepage/核心1.png",
      title: "供热云",
      substance: "云端协同与数据驱动",
      more: "全链路智能化管控",
      id: 1,
    },
    {
      img: "../imgs/homepage/核心2.png",
      title: "供热智能体",
      substance: "多技术融合驱动智能升级",
      more: "覆盖供热全生命周期",
      id: 2,
    },
    {
      img: "../imgs/homepage/核心3.png",
      title: "供热数据集",
      substance: "智能热网监控与调度",
      more: "精准供热与需求侧管理",
      id: 3,
    },
    {
      img: "../imgs/homepage/核心4.png",
      title: "物联网",
      substance: "多能互补与综合能源服务",
      more: "低碳化与可持续发展",
      id: 4,
    },
    {
      img: "../imgs/homepage/核心5.png",
      title: "区块链",
      substance: "流程自动化与降本增效",
      more: "多方协作与生态构建",
      id: 5,
    },
    {
      img: "../imgs/homepage/核心6.png",
      title: "供热模型",
      substance: "区域供热系统仿真",
      more: "智能优化模型",
      id: 6,
    },
    {
      img: "../imgs/homepage/核心7.png",
      title: "可信数据空间",
      substance: "核心内涵与价值定位",
      more: "技术支撑体系",
      id: 7,
    },
  ];
  $.each(coreData, function (index, item) {
    let coreTemplate = `
                          <div class="core-contentchild">
                            <img src="${item.img}" alt="">
                            <div class="core-synopsis">
                                <div>${item.title}</div>
                                <div>${item.substance}</div>
                                <div>${item.more}</div>
                            </div>
                        </div> 
                         `;
    $(".core-content").append(coreTemplate);
  });
  let coreTemplateMore = `
                            <div class="core-contentchild">
                                <img src="../imgs/homepage/核心more.png" alt="">
                                <div class="core-more">MORE&nbsp;+</div>
                            </div>
                            `;

  $(".core-content").append(coreTemplateMore);
}
